import { render, staticRenderFns } from "./EmailContentPopup.vue?vue&type=template&id=ef8a0260&scoped=true&"
import script from "./EmailContentPopup.vue?vue&type=script&lang=ts&"
export * from "./EmailContentPopup.vue?vue&type=script&lang=ts&"
import style0 from "./EmailContentPopup.vue?vue&type=style&index=0&id=ef8a0260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8a0260",
  null
  
)

export default component.exports